import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../app/hooks';
import { AddEventUserIcon } from "../../images/Icons"
import { setAlias, setUserEmail } from './currentEventUserSlice'

import '../../App.css'

export function AddEventUserButton() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    return (
        <div className='iconButton' onClick={() => {
            dispatch(setAlias(''))
            dispatch(setUserEmail(''))
            navigate('/AddEventUser')
        }}>
            <AddEventUserIcon />
        </div>
    )
}